const JBP_PLANNING = 'jbp-planning'

export const JBP_POWER_TOTAL = '-power-total'
export const JBP_POWER = '-power'
export const JBP_NON_POWER = '-non-power'
export const JBP_SOB = '-sob'

export const subTitleTranslation = {
  quota: `${JBP_PLANNING}-quota`,
  actuals: `${JBP_PLANNING}-actuals`,
  actualsDirect: `${JBP_PLANNING}-actuals-direct`,
  actualsIndirect: `${JBP_PLANNING}-actuals-indirect`,
  actualsSmb: `${JBP_PLANNING}-actuals-smb`,
  actualsEu: `${JBP_PLANNING}-actuals-eu`,
  targetsSmb: `${JBP_PLANNING}-targets-smb`,
  targetsEu: `${JBP_PLANNING}-targets-eu`,
  targets: `${JBP_PLANNING}-targets`,

  partner: {
    count: `${JBP_PLANNING}-partner-count`,
    percent: `${JBP_PLANNING}-partner-percent`,
    yoy: `${JBP_PLANNING}-partner-yoy`,
    qoq: `${JBP_PLANNING}-partner-qoq`,
  },

  yoy: {
    ava: `${JBP_PLANNING}-yoy-ava`,
    pva: `${JBP_PLANNING}-yoy-pva`,
    pvp: `${JBP_PLANNING}-yoy-pvp`,
    qva: `${JBP_PLANNING}-yoy-qva`,
  },

  achiev: {
    targets: `${JBP_PLANNING}-targets-achiev`,
    quota: `${JBP_PLANNING}-quota-achiev`,
  },

  qoq: {
    ava: `${JBP_PLANNING}-qoq-ava`,
    pva: `${JBP_PLANNING}-qoq-pva`,
    pvp: `${JBP_PLANNING}-qoq-pvp`,
    qva: `${JBP_PLANNING}-qoq-qva`,
  },
}
